module.exports = __webpack_public_path__ + "static/p-01c402507032afd2831a9295f56806b8.jpg";